import { createPinia } from 'pinia'

// shared instance to be used in all vue apps
export const pinia = createPinia()
